import Vue from 'vue'
import Vuex from 'vuex'
import state from './initial-state'
import { CORE, VIEWS, MENU, DATA } from './mutations'
import groups from './modules/groups'
import members from './modules/members'
import session from './modules/session'
import paymentOptions from './modules/payment-options'
import taxes from './modules/taxes'
import users from './modules/users'
import campaigns from './modules/campaigns'
import templates from './modules/templates'
import notifications from './local/notifications'
import L from 'services/Localization'

const strict = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

export default new Vuex.Store({
  strict,
  state,
  mutations: {
    [CORE.SET_USER](state, user) {
      state.user = user
    },
    [CORE.SET_LANG](state, lang) {
      state.lang = lang
    },
    [CORE.SET_MENU](state, menus) {
      menus.forEach(m => { m.expanded = false })
      state.menu = menus
    },
    [CORE.READY](state) {
      state.ready = true
    },
    [CORE.UPDATE_BRANCH](state, index) {
      state.branch = index
    },
    [MENU.TOGGLE](state, index) {
      state.menu[index].expanded = !state.menu[index].expanded
    },
    [MENU.CLOSE](state) {
      state.menu.forEach(menu => {
        menu.expanded = false
      })
    },
    [VIEWS.SET_STATE](state, { view, data }) {
      let currentState = state.views[view]
      Object.keys(data).forEach(key => {
        Vue.set(currentState, key, data[key])
      })
    },
    [VIEWS.READY](state, view) {
      state.views[view].ready = true
    },
    [DATA.SET_VALIDATION_ERRORS](state, errors) {
      let validation = {}
      if (errors.validationErrors && errors.validationErrors.length > 0) {
        validation.hasError = true
        errors.validationErrors.forEach(function (error) {
          error.members.forEach(function (member) {
            validation[member] = validation[member] || {}
            validation[member].messages = validation[member].messages || []
            validation[member].messages.push(error.message)
          })
        })
      } else {
        validation = {}
      }
      Vue.set(state, 'validation', validation)
    },
    [DATA.REMOVE_VALIDATION_ERRORS](state) {
      state.validation = {}
    }
  },

  actions: {
    fetch_core({ dispatch }) {
      dispatch('set_lang', L.getLanguages())
      Promise.all([
        dispatch('getUserSession'),
        dispatch('getTenantSession')
      ]).then(() => {
        dispatch('set_core')
      })
    },
    set_core({ commit }) {
      commit('core/READY')
    },
    set_lang({ commit }, { lang }) {
      commit(CORE.SET_LANG, lang)
    },
    set_menu({ commit }, { menus }) {
      commit(CORE.SET_MENU, menus)
    }
  },
  modules: {
    users,
    groups,
    members,
    session,
    paymentOptions,
    taxes,
    campaigns,
    templates,
    notifications
  },

  getters: {
    getViewData: state => view => state.views[view].data,
    getLanguages: state => state.lang,
    getValidation: state => state.validation
  }
})



// WEBPACK FOOTER //
// ./scripts/store/index.js